import createPdf from './base.js';
import { logo_ficha } from 'assets/img/logo-ficha.js'


const fichaPDF = async (output, { ficha, paciente, listaItemsLaboratorio }) => {


  var fechaDeNacimiento = new Date(paciente[0].fecha_nac);
  var hoy = new Date();
  const milisegundosPorAnio = 1000 * 60 * 60 * 24 * 365;
  let edadAños = parseInt((hoy - fechaDeNacimiento) / milisegundosPorAnio);
  let edadMeses = 0
  let edadDias = 0
  if (parseInt((hoy - fechaDeNacimiento) / milisegundosPorAnio) < 1) {
    let edad = Math.round(((hoy - fechaDeNacimiento) / milisegundosPorAnio) * 365);

    if (parseInt(edad) < 31) {
      edadDias = parseInt(edad)
    }
    if (edad > 30) {

      edadMeses = parseInt(edad / 30)
      edadDias = parseInt(edad - 30)

    }
  }

  let dataLaboratorio = [
    [
      { text: "#", style: "nhcheader", alignment: "left", },
      { text: "ITEM", style: "nhcheader", alignment: "left", },
      {
        text: "POSITIVO",
        style: "nhcheader",
        alignment: "left",
      },
      {
        text: "NEGATIVO",
        style: "nhcheader",
        alignment: "left",
      },
      {
        text: "INDETERMINADO",
        style: "nhcheader",
        alignment: "left",
      },

    ],
  ];
  for (let e of listaItemsLaboratorio) {
    dataLaboratorio.push([
      { text: e.id_items_diagnostico, style: "text", alignment: "left", margin: [0, 10, 0, 0] },
      { text: e.items_diagnostico, style: "text", alignment: "left", margin: [0, 10, 0, 0] },
      { text: e.positivo, style: "text", alignment: "left", margin: [0, 10, 0, 0] },
      { text: e.negativo, style: "text", alignment: "left", margin: [0, 10, 0, 0] },
      { text: e.indeterminado, style: "text", alignment: "left", margin: [0, 10, 0, 0] },
    ]);
  }
  let titulo = 'VIGILANCIA EPIDEMIOLOGICA DE ENFERMEDADES TRANSMITIDAS POR VECTORES '
  let subtitulo = 'FICHA EPIDEMIOLÓGICA DE CHAGAS '

  const content = [
    {
      margin: [0, 0, 0, 0],

      table: {
        widths: ['30%', '50%', '20%'],
        body: [
          [
            {
              image: logo_ficha,
              fit: [160.73, 100.692],
              alignment: 'left',
              margin: [0, 0, 0]
            },
            { text: titulo, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0] },
            { text: 'CODIGO                ', style: 'header', alignment: 'left', margin: [2, 5, 0, 0], },
          ],
          [

            {},
            { text: subtitulo, style: 'titulo', alignment: 'center', },
            { text: 'N°' + ficha[0].numero, style: 'text', alignment: 'rigth', margin: [3, 0, 0, 10], color: 'red', fontSize: 12 },

          ],


        ],
      },
      layout: 'noBorders',


    },

    //TIPO Y NUMERO DOCUMENTO


    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: '1. DATOS GENERALES', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },
    {
      margin: [0, 0, 0, 0],

      table: {
        widths: ['16%', '12%', '18%', '18%', '18%', '20%',],
        body: [
          [
            { text: 'Fecha Notificacion', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'Semana Epidemilogica', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'SEDES', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'Coordenacion de Red', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'Municipio', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'Est. de salud', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },

          ],
          [
            { text: ficha[0].notificacion.split('T')[0], style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], },
            { text: ficha[0].semana, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fontSize: 6, },
            { text: 'CHUQUISACA', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0] },
            { text: ficha[0].red, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0] },
            { text: ficha[0].municipio, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0] },
            { text: ficha[0].hospital, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], },
          ],

        ],
      },








      layout: {
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
        },

      }


    },
    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: '2. DATOS Y ANTECEDENTES DEL PACIENTE', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },
    {
      margin: [0, 0, 0, 0],

      table: {
        widths: ['19%', '16%', '16%', '20%', '18%', '13%',],
        body: [
          [
            { text: 'Nombre', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'Apelido paterno', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'Apellido materno', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'sexo', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded', fontSize: 6, },
            { text: 'Edad', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'Cedula de identidad', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fontSize: 6, fillColor: '#eaeded' },

          ],
          [
            { text: ficha[0].nombre_paciente, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], },
            { text: ficha[0].apellido_paterno, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fontSize: 6, },
            { text: ficha[0].apellido_materno, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0] },
            {
              table: {
                widths: ['50%', '50%'],
                body: [
                  [
                    { text: 'Masculino', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                    { text: 'Femenino', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                  ],
                  [
                    { text: paciente[0].sexo == 1 ? 'Si' : '-', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                    { text: paciente[0].sexo == 2 ? 'Si' : '-', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                  ],
                ],
              },
              layout: {
                hLineColor: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
                },
                vLineColor: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
                },
              }
            },
            {
              table: {
                widths: ['31%', '39%', '30%'],
                body: [
                  [
                    { text: 'Años', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                    { text: 'Meses', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                    { text: 'Dias', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                  ],
                  [
                    { text: edadAños, style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                    { text: edadMeses, style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                    { text: edadDias, style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                  ],
                ],
              },
              layout: {
                hLineColor: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
                },
                vLineColor: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
                },
              }

            }
            ,
            { text: ficha[0].ci ? ficha[0].ci : 'TUTOR: ' + ficha[0].ci_tutor, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], },
          ],

        ],
      },
    },

    {
      margin: [0, 0, 0, 0],

      table: {
        widths: ['20%', '20%', '20%', '25%', '17%',],
        body: [
          [
            { text: 'Fecha de nacimiento', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'Ocupacion', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fillColor: '#eaeded' },
            { text: 'Celular/Telefono', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fillColor: '#eaeded' },
            { text: 'Si es mujer, ¿esta embarazada?', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fillColor: '#eaeded', fontSize: 6, },
            { text: 'FUM', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fillColor: '#eaeded' },

          ],
          [
            { text: paciente[0].fecha_nac.split('T')[0], style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6, },
            { text: paciente[0].ocupacion, style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
            { text: paciente[0].celular, style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
            {
              table: {
                widths: ['50%', '50%'],
                body: [

                  [
                    { text: paciente[0].sexo == 2 ? ficha[0].mujerEmbarazada == 1 ? 'SI:X' : 'SI:' : '-', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                    { text: paciente[0].sexo == 2 ? ficha[0].mujerEmbarazada == 0 ? 'NO:X' : 'NO:' : '-', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                  ],
                ],
              },
              layout: {
                hLineColor: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
                },
                vLineColor: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
                },
              }
            },
            { text: ficha[0].fum?.split('T')[0], style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], },
          ],

        ],
      },
    },
    { text: !paciente[0].nombre ? 'En caso de que el paciente sea menor de edad, datos del padre o tutor: ' + paciente[0].nombre_tutor : 'En caso de que el paciente sea menor de edad, datos del padre o tutor:____________________________________________', style: 'text', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6 },
    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: 'Antecedentes Patologicos', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },

          ],
        ],
      },
      layout: {
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
        },
      }
    },
    {
      table: {
        widths: ['35%', '35%', '30%'],
        body: [
          [
            { text: ficha[0].transfusionSangre ? 'Recibió transfusión de sangre? SI:X  NO: - ' : 'Recibió transfusión de sangre? SI:-  NO: X ', style: 'text', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].madreSerologica ? 'Nacio de madre con serología (+) para Chagas?  SI:X  NO: - ' : 'Nacio de madre con serología (+) para Chagas?   SI:-  NO: X ', style: 'text', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].tuboTransplante ? ' Tuvo trasplante de Órgano?   SI:X  NO: - ' : ' Tuvo trasplante de Órgano?   SI:-  NO: X ', style: 'text', alignment: 'right', margin: [0, 0, 0, 0], fontSize: 6 },


          ],
        ],
      },

      layout: 'noBorders',
    },

    {
      table: {
        widths: ['50%', '52%',],
        body: [
          [
            { text: ficha[0].carneMalCocida ? 'Consumio carne de animal mal cocida? (Amazonia) SI:X  NO: - ' : 'Consumio carne de animal mal cocida? (Amazonia)     SI:-  NO: X ', style: 'text', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].otraInformacion ? 'Otro : ' + ficha[0].otraInformacion : 'Otro:___________________________________________________________________________________', style: 'text', alignment: 'right', margin: [0, 0, 0, 0], fontSize: 6 },
          ],
        ],
      },

      layout: 'noBorders',
    },

    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: '3. RESIDENCIA ACTUAL DEL PACIENTE', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },

    {
      margin: [0, 0, 0, 0],

      table: {
        widths: ['17%', '19%', '20%', '20%', '26%',],
        body: [
          [
            { text: 'Departamento', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'Municipio', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fillColor: '#eaeded' },
            { text: ' Distrito/Localidad/comunidad', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fillColor: '#eaeded' },
            { text: 'Barrio/Zona/ U.V.', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fillColor: '#eaeded', fontSize: 6, },
            { text: 'Tiempo y Permanencia', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fillColor: '#eaeded' },

          ],
          [
            { text: !ficha[0].idDepartamentoResidencia ? ficha[0].otroPaisResidencia : ficha[0].departamentoResidencia, style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6, },

            { text: ficha[0].municipioResidencia, style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
            { text: ficha[0].comunidadResidencia, style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
            { text: ficha[0].comunidadResidencia, style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
            {
              table: {
                widths: ['18%', '24%', '18%', '42%'],
                body: [
                  [
                    { text: 'Dias', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
                    { text: 'Meses', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
                    { text: 'Años', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
                    { text: ficha[0].permanenciaResidencia ? 'Temporal SI' : 'Temporal -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6, },
                  ],
                  [
                    { text: ficha[0].diasResidencia, style: 'subtitulo', alignment: 'center', fontSize: 6, margin: [0, 0, 0, 0] },
                    { text: ficha[0].mesesResidencia, style: 'subtitulo', alignment: 'center', fontSize: 6, margin: [0, 0, 0, 0] },
                    { text: ficha[0].añosResidencia, style: 'subtitulo', alignment: 'center', fontSize: 6, margin: [0, 0, 0, 0], },
                    { text: !ficha[0].permanenciaResidencia ? 'Indefinido SI' : 'Indefinido -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6, },
                  ],
                ],
              },
              layout: {
                hLineColor: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
                },
                vLineColor: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
                },
              }
            },
          ],

        ],
      },
    },



    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: '4. ANTECEDENTES EPIDEMIOLÓGICOS', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },

    {
      table: {
        widths: ['102%',],
        body: [
          [
            { text: ficha[0].viveZonaEndemica ? 'Vive o visito zona endémica para Chagas? SI:X  NO: - ' : 'Vive o visito zona endémica para Chagas?     SI:-  NO: X ', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], },
          ],
        ],
      },

      layout: {
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
        },
      }
    },

    {
      table: {
        widths: ['25%', '25%', '27%', '25%',],
        body: [
          [
            { text: 'Departamento', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'Municipio', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fillColor: '#eaeded' },
            { text: ' Distrito/Localidad/comunidad', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fillColor: '#eaeded' },
            { text: 'Barrio/Zona/ U.V.', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fillColor: '#eaeded', fontSize: 6, },
          ],
          [
            { text: ficha[0].departamentoEndemica, style: 'text', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].municipioEndemica, style: 'text', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].comunidadEndemica, style: 'text', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].barrioEndemica, style: 'text', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6 },

          ],
        ],
      },

      layout: {
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
        },
      }
    },

    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: ' 5. DATOS CLÍNICOS - CLASIFICACIÓN DE CASO', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },
    { text: '(Marque con una X los signos y síntomas que presenta el/la paciente)', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
    {
      table: {
        widths: ['52%', '20%', '10%', '10%', '10%'],
        body: [
          [
            { text: 'FASE AGUDA', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'Fecha de Inicio de Sintonas', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fillColor: '#eaeded' },
            { text: ficha[0]?.fechaInicioSintomasAgudas ? 'Día   ' + ficha[0]?.fechaInicioSintomasAgudas?.split('T')[0]?.split('-')[2] || 'Día -' : 'Dia -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
            { text: ficha[0]?.fechaInicioSintomasAgudas ? 'Mes   ' + ficha[0]?.fechaInicioSintomasAgudas?.split('T')[0]?.split('-')[1] || 'Mes -' : 'Mes -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
            { text: ficha[0]?.fechaInicioSintomasAgudas ? 'Año   ' + ficha[0]?.fechaInicioSintomasAgudas?.split('T')[0]?.split('-')[0] || 'Año -' : 'año -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
          ],
        ],
      },

      layout: {
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
        },
      }
    },

    {
      table: {
        widths: ['18%', '16%', '20%', '16%', '16%', '16%'],
        body: [
          [
            { text: ficha[0].asintomaticoAgudo ? 'Asintomatico: SI' : 'Asintomatico: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].fiebreMayor7dias ? ' Fiebre > a 7 dias: SI' : ' Fiebre > a 7 dias: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].chagomaInoculacion ? 'Chagoma de Inoculacion: SI' : 'Chagoma de Inoculacion: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].signoRomaña ? 'Signo de Romaña: SI' : 'Signo de Romaña: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].adenopatia ? 'Adenopatia: SI' : 'Adenopatia: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].irritabilidad ? 'Irritabilidad: SI' : 'Irritabilidad: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
          ],
        ],
      },

      layout: {
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
        },
      }
    },

    {
      table: {
        widths: ['18%', '20%', '20%', '44%'],
        body: [
          [
            { text: ficha[0].diarreas ? 'Diarreas: SI' : 'Diarreas: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].hepatoesplenomegalia ? ' Hepatoesplenomegalia: SI' : ' Hepatoesplenomegalia: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].convulsiones ? 'Convulsiones: SI' : 'Convulsiones: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].otrosSintomasAgudos ? ' Otros:' + ficha[0].otrosSintomasAgudos : 'Otros:_________________________________________________________________', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
          ],
        ],
      },

      layout: {
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
        },
      }
    },


    {
      table: {
        widths: ['52%', '20%', '10%', '10%', '10%'],
        body: [
          [
            { text: 'FASE CRONICA', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'Fecha de Inicio de Sintonas', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fillColor: '#eaeded' },
            { text: ficha[0]?.fechaInicioSintomasCronicas ? 'Día   ' + ficha[0]?.fechaInicioSintomasCronicas?.split('T')[0]?.split('-')[2] || 'Dia -' : 'Dia -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
            { text: ficha[0]?.fechaInicioSintomasCronicas ? 'Mes   ' + ficha[0]?.fechaInicioSintomasCronicas?.split('T')[0]?.split('-')[1] || 'Mes -' : 'Mes -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
            { text: ficha[0]?.fechaInicioSintomasCronicas ? 'Año   ' + ficha[0]?.fechaInicioSintomasCronicas?.split('T')[0]?.split('-')[0] || 'Año -' : 'Año -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
          ],
        ],
      },

      layout: {
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
        },
      }
    },

    {
      table: {
        widths: ['15%', '15%', '15%', '17%', '40%'],
        body: [
          [
            { text: ficha[0].asintomaticoCronico ? 'Asintomatico: SI' : 'Asintomatico: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].alteracionesCardiacas ? ' Alt. Cardiacas: SI' : ' Alt. Cardiacas: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].alteracionesDigestivas ? 'Alt. Digestivas: SI' : 'Alt. Digestivas: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].alteracionesNerviosas ? 'Alt. Sistema Nervioso: SI' : 'Alt. Sistema Nervioso: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].otrosSintomasCronicas ? ' Otros:' + ficha[0].otrosSintomasCronicas : 'Otros:_______________________________________________________________', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },

          ],
        ],
      },

      layout: {
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
        },
      }
    },


    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: '6. FORMA DE TRANSMISIÓN', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },
    {
      table: {
        widths: ['10%', '10%', '10%', '15%', '17%', '40%'],
        body: [
          [
            { text: ficha[0].oral ? 'Oral: SI' : 'Oral: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].vectorial ? ' Vectorial: SI' : ' Vectorial: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].congenito ? 'Congénito: SI' : 'Congénito: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].transfucional ? 'Transfusional: SI' : 'Transfusional: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].transplante ? 'Trasplantes: SI' : 'Trasplantes: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].otrasTransmisiones ? ' Otros:' + ficha[0].otrasTransmisiones : 'Otros:____________________________________________________________', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
          ],
        ],
      },

      layout: {
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
        },
      }
    },
    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: '7. CLASIFICACIÓN DEL CASO', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },

    {
      table: {
        widths: ['50%', '52%'],
        body: [
          [
            { text: ficha[0].agudo ? 'Agudo: SI' : 'Oral: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ficha[0].cronico ? ' Cronico: SI' : ' Vectorial: -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
          ],
        ],
      },

      layout: {
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
        },
      }
    },

    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: '8. EXÁMENES DE LABORATORIO', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },



    {
      table: {
        widths: ['25%', '32%', '24%', '7%', '7%', '7%'],
        body: [
          [
            { text: 'TIPO DE MUESTRA', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: listaItemsLaboratorio[0].tipo_de_muestra, style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], },
       
   
            { text: 'fecha toma muestra', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: listaItemsLaboratorio[0].fecha_toma_muestra ? 'Día   ' + listaItemsLaboratorio[0]?.fecha_toma_muestra?.split('T')[0]?.split('-')[2] : 'Día -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
            { text: listaItemsLaboratorio[0].fecha_toma_muestra ? 'Mes   ' + listaItemsLaboratorio[0]?.fecha_toma_muestra?.split('T')[0]?.split('-')[1] : 'mes -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
            { text: listaItemsLaboratorio[0].fecha_toma_muestra ? 'Año   ' + listaItemsLaboratorio[0]?.fecha_toma_muestra?.split('T')[0]?.split('-')[0] : 'Año -', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
          ],
        ],
      },

      layout: {
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
        },
      }
    },




    {
      margin: [0, 0, 0, 0],

      table: {
        widths: ['26%', '26%', '25%','25%',],
        body: [

          [
          

            {
              table: {
                widths: ['60%', '42%',],
                body: [
                  [
                    { text: '', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
                    { text: 'CONCLUSION', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
               
                  ],
                  [
                    { text: listaItemsLaboratorio[0].nombre, style: 'subtitulo', alignment: 'center', fontSize: 5, margin: [0, 0, 0, 0] },
                    { text: listaItemsLaboratorio[0].conclusion, style: 'subtitulo', alignment: 'center', fontSize: 6, margin: [0, 0, 0, 0] },
                  ],
                  [
                    { text: listaItemsLaboratorio[1].nombre, style: 'subtitulo', alignment: 'center', fontSize: 5, margin: [0, 0, 0, 0] },
                    { text: listaItemsLaboratorio[1].conclusion, style: 'subtitulo', alignment: 'center', fontSize: 6, margin: [0, 0, 0, 0] },
                  ],
                ],
              },
              layout: {
                hLineColor: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
                },
                vLineColor: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
                },
              }
            },
           
            
            {
              table: {
                widths: ['60%', '42%',],
                body: [
                  [
                    { text: '', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
                    { text: 'CONCLUSION', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
               
                  ],
                  [
                    { text: listaItemsLaboratorio[2].nombre, style: 'subtitulo', alignment: 'center', fontSize: 6, margin: [0, 0, 0, 0] },
                    { text: listaItemsLaboratorio[2].conclusion, style: 'subtitulo', alignment: 'center', fontSize: 6, margin: [0, 0, 0, 0] },
                  ],
                  [
                    { text: listaItemsLaboratorio[3].nombre, style: 'subtitulo', alignment: 'center', fontSize: 6, margin: [0, 0, 0, 0] },
                    { text: listaItemsLaboratorio[3].conclusion, style: 'subtitulo', alignment: 'center', fontSize: 6, margin: [0, 0, 0, 0] },
                  ],
                ],
              },
              layout: {
                hLineColor: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
                },
                vLineColor: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
                },
              }
            },

            {
              table: {
                widths: ['60%', '42%', ],
                body: [
                  [
                    { text: '', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
                    { text: 'CONCLUSION', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
               
                  ],
                  [
                    { text: listaItemsLaboratorio[4].nombre, style: 'subtitulo', alignment: 'center', fontSize: 5, margin: [0, 0, 0, 0] },
                    { text: listaItemsLaboratorio[4].conclusion, style: 'subtitulo', alignment: 'center', fontSize: 6, margin: [0, 0, 0, 0] },
                  ],
                  [
                    { text: listaItemsLaboratorio[5].nombre, style: 'subtitulo', alignment: 'center', fontSize: 5, margin: [0, 0, 0, 0] },
                    { text: listaItemsLaboratorio[5].conclusion, style: 'subtitulo', alignment: 'center', fontSize: 6, margin: [0, 0, 0, 0] },
                  ],
                ],
              },
              layout: {
                hLineColor: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
                },
                vLineColor: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
                },
              }
            },
            {
              table: {
                widths: ['60%', '42%', ],
                body: [
                  [
                    { text: '', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
                    { text: 'CONCLUSION', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
               
                  ],
                  [
                    { text: listaItemsLaboratorio[6].nombre, style: 'subtitulo', alignment: 'center', fontSize: 6, margin: [0, 0, 0, 0] },
                    { text: listaItemsLaboratorio[6].conclusion, style: 'subtitulo', alignment: 'center', fontSize: 6, margin: [0, 0, 0, 0] },
                  ],
                  [
                    { text: listaItemsLaboratorio[7].nombre, style: 'subtitulo', alignment: 'center', fontSize: 6, margin: [0, 0, 0, 0] },
                    { text: listaItemsLaboratorio[7].conclusion, style: 'subtitulo', alignment: 'center', fontSize: 6, margin: [0, 0, 0, 0] },
                  ],
                ],
              },
              layout: {
                hLineColor: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
                },
                vLineColor: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
                },
              }
            },

          ],

        ],
      },
    },














    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: '9. RESPONSABLE DEL LLENADO DE LA FICHA', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },

    {
      table: {
        widths: ['25%', '25%', '25%', '27%'],
        body: [
          [
            { text: 'Nombres y apellidos', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], },
            { text: 'Cargo', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], },
            { text: ' Teléfono / celular', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], },
            { text: ' Firma y sello', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], },
          ],
          [
            { text: ficha[0].usuario, style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ' ', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ' ', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: ' ', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0], fontSize: 6 },
          ],
        ],
      },

      layout: {
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
        },
      }
    },

    { text: '__________________________________________________________________________', style: 'piePagina', alignment: 'center', margin: [0, 50, 0, 0], },
    { text: 'PROFESIONAL MEDICO', style: 'text', alignment: 'center', },
    { text: ficha[0].medico, style: 'piePagina', alignment: 'center', },

  ];

  const response = await createPdf({ content }, output);
  return response;
};

export { fichaPDF };
